define([], function () {
  var getDeleteConfirmText = function(ids){
    var app_table = $('.applicants-list > table.table');
    var deleted = 0;
    var failed_to_delete = 0;

    $.each(ids, function(){
      var state = app_table.find('tr.short-data[data-id='+this+']').attr('data-state');
      if(state == 'new'){
        deleted += 1;
      } else {
        failed_to_delete += 1;
      }
    });

    return 'Deleted: '+deleted+' candidates\nFailed to delete: '+failed_to_delete+' candidates';
  };

  var getIds = function(id){
    var result = [];

    if(id){
      result = [id];
    } else {
      $('.check-applicant:checked').each(function(){
        result.push($(this).val());
      });
    }

    return result;
  };

  var setCaColumnsWidthCookies = function(table){
    var result = { table: table.width() };

    $.each(table.find('th'), function(){
      result[$(this).attr('data-name')] = $(this).width();
    });

    $.cookie('ca_columns_width',  JSON.stringify(result, null, '\t'), {json: true});
  };

  var updateResizableColumns = function(width){
    var app_table = $('.applicants-list > table.table');
    var app_table_th = app_table.find('th.resizable');
    var table_width = width || app_table.width();
    var change_width = 0;

    app_table.css('width', table_width);

    if(app_table.find('.ui-resizable-handle').length > 0){
      app_table_th.resizable('destroy');
    }

    app_table_th.resizable({
      handles: 'e',
      resize: function(e, ui){
        change_width = (ui.size.width - ui.originalSize.width);
        app_table.css('width', (table_width + change_width));
      },
      stop: function(e, ui){
        table_width += change_width;
        setCaColumnsWidthCookies(app_table);
      }
    });
  };

  var setState = function(e, id, delete_apps){
    var app_ids = getIds(id);
    var link = $(e.currentTarget);

    if(app_ids.length > 0){
      link.attr('href', link.attr('href') + '&applicant[app_ids]=' + app_ids);

      if(delete_apps){
        link.attr('data-confirm', getDeleteConfirmText(app_ids));
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var setUrlParams = function(e){
    var app_ids = getIds();
    var link = $(e.currentTarget);

    if(app_ids.length > 0){
      link.attr('href', link.attr('href') + '?applicant[app_ids]=' + app_ids);
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var transferToJob = function(e){
    var form = $(e.currentTarget);
    var job_id = form.find('#applicant_job_id').val();
    var app_ids = getIds();

    if((app_ids.length > 0) && job_id){
      var input = $('<input id="app_ids" type="hidden" name="applicant[app_ids]" value="'+app_ids+'">');
      form.prepend(input);
      form.submit();
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var validateEmail = function(sEmail) {
    var r = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
    return (sEmail.match(r) == null) ? false : true;
  };

  var sendEmail = function(e, send, id){
    var app_ids = getIds(id);
    var form = $(e.currentTarget).parents('form');
    var email_content;
    var reply_to = form.find('#applicant_reply_to');
    var valid_reply_to = true;
    var accept_replies = form.find('#applicant_accept_replies:checked').length > 0;

    form.find('.error').remove();

    if(accept_replies){
      valid_reply_to = validateEmail(reply_to.val());
    }

    if(form.find('iframe.cke_wysiwyg_frame').length > 0){
      email_content = form.find('iframe.cke_wysiwyg_frame').contents().find('body').text();
    } else {
      email_content = (form.find('#applicant_template_tmpl') || form.find('#applicant_template')).val();
    }

    if(!valid_reply_to){
      reply_to.after('<span class="error">'+'is invalid'+'</span>')
    }

    if(app_ids.length > 0 && valid_reply_to && ((send && email_content.length > 0) || !send)){
      var input = $('<input type="hidden" name="applicant[app_ids]" value="'+app_ids+'">');
      form.prepend(input);

      if(!send){
        var skip_email_input = $('<input type="hidden" name="applicant[skip_email]" value="true">');
        form.prepend(skip_email_input);
      }

      form.submit();
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var updateColumn = function(checkbox, dropdown, element, update_table){
    var fields = [];
    var url = dropdown.data('url');
    var test = dropdown.data('test');

    dropdown.find('li').append('<div class="loading"></div>');

    dropdown.find('.check-app-field:checked').each(function(){
      fields.push($(this).val());
    });

    $.ajax({
      type: 'PUT',
      url: url,
      data: { app_fields: fields, test: test },
      success: function(result){
        if(result.status == 'ok'){
          if(checkbox.prop('checked')){
            element.find('.' + checkbox.val()).removeClass('hidden');
            element.find('.check').removeClass('hidden');
            $('.actions-wrapper .show-hide-all').show();
            $('.applicants-list .no-applicants').hide();
          } else {
            if(dropdown.hasClass('applicant-filters')){
              var select = element.find('.' + checkbox.val() + ' .chosen-select-with-search');
              select.val(' ').trigger('chosen:updated');
              select.parents('.form-group').find('.not-in').addClass('hidden');
            }
            element.find('.' + checkbox.val()).addClass('hidden');
            if(fields.length <= 0){
              element.find('.check').addClass('hidden');
              element.find('.check .checkbox-icheck.check-applicant').iCheck('uncheck');
              $('.actions-wrapper .show-hide-all').hide();
              $('.applicants-list .no-applicants').show();
            }
          }
          setCaColumnsWidthCookies($('.applicants-list > table.table'));
        }

        dropdown.find('li .loading').remove();
      }
    });
  };

  var sendToCvScreening = function(e, id){
    var app_ids = getIds(id);
    var form = $(e.currentTarget);
    var url = form.attr('action');
    var member_id = form.find('#applicant_member_id').val();
    var result_area = $('.applicant-action-cv-screening.form-wrap ul.results');
    result_area.html('');

    if(member_id){
      form.parents('.loading-wrapper').prepend('<div class="ca-loading"></div>');
      var done = app_ids.length;
      var send_mail = false;

      $.each(app_ids, function(){
        var data = { applicant: { id: this, member_id: member_id } };
        done -= 1;

        if(done == 0){
          data.applicant.send_mail = send_mail;
        }

        $.ajax({
          type: 'PUT',
          url: url,
          data: data,
          async: false,
          success: function(result){
            if(result.status == 'ok'){
              send_mail = true;
              var state_button = $('.table-wrap.applicants-list tr[data-id='+result.app_id+'] .applicant-state button');
              state_button.attr('class', result.app_state);
              state_button.find('span.text').html(result.new_state);
            }

            //var app_html = '<li class="'+result.status+'"><span>'+ result.app_name +':</span> ';
            //$.each(result.messages, function(){ app_html += this + '; '; });
            //app_html += '</li>';
            //
            //result_area.append(app_html);
            if(done == 0){
              result_area.append('<li>Done</li>');
              $('.form-wrap .ca-loading').remove();
            }
          }
        });
      });
    } else {
      result_area.append('<li class="error">Please, select a company member</li>');
    }
  };

  var applyToJob = function(e){
    var app_ids = getIds();
    var form = $(e.currentTarget);
    var url = form.attr('action');
    var job_id = form.find('#interest_job_id').val();
    var result_area = $('.interest-action-apply-to-job.form-wrap ul.results');
    result_area.html('');

    if(job_id){
      form.parents('.loading-wrapper').prepend('<div class="ca-loading"></div>');
      var done = app_ids.length;

      $.each(app_ids, function(){
        var data = { interest: { id: this, job_id: job_id } };

        $.ajax({
          type: 'PUT',
          url: url,
          data: data,
          success: function(result){
            done -= 1;
            if(result.status == 'ok'){
              $('.table-wrap.applicants-list tr[data-id='+result.app_id+'] td.state').html(result.new_state);
            }

            app_html = '<li class="'+result.status+'"><span>'+ result.app_name +':</span> ';
            $.each(result.messages, function(){ app_html += this + '; '; });
            app_html += '</li>';

            result_area.append(app_html);

            if(done == 0){
              $('.form-wrap .ca-loading').remove();
            }
          }
        });
      });
    } else {
      result_area.append('<li class="error">Please, select a job</li>');
    }
  };

  var test = function(e, app_ids){
    var form = $(e.currentTarget);
    var url = form.attr('action');
    var test_id = form.find('#applicant_test_id:checked').val();
    var timeframe_to_pass = form.find('#applicant_timeframe_to_pass').val();
    var test_modal = $('.modal.applicant-test-modal');
    var test_confirm_modal = $('.modal.test-confirm-modal');
    var errors = testErrors();

    if(test_id && errors.test_data.length <= 0 && errors.check_test <= 0){
      form.parents('.loading-wrapper').prepend('<div class="ca-loading"></div>');
      var done = app_ids.length;
      var deducted = 0;
      var action_time = parseInt(Date.parse(new Date) / 1000);

      $.each(app_ids, function(){
        var data = { applicant: { id: this, test_id: test_id, timeframe_to_pass: timeframe_to_pass, action_time: action_time } };
        done -= 1;

        $.ajax({
          type: 'PUT',
          url: url,
          data: data,
          async: false,
          success: function(result){
            var app_html = '<li class="'+result.status+'">- ' + result.app_name;
            if(result.messages.length > 0){
              app_html += '<span class="result-message">(';
              $.each(result.messages, function(){ app_html += this + '; '; });
              app_html += ')</span>';
            }
            app_html += '</li>';
            if(result.deducted && result.messages.length <= 0){ deducted += result.deducted; }
            test_confirm_modal.find('.results').append(app_html);

            if(done == 0){
              test_confirm_modal.find('.confirm-confirmation .desc').html(result.apply_message);
              if(result.timeframe_to_pass){
                test_confirm_modal.find('.confirm-what-next .deadline').html('- ' + result.timeframe_to_pass + ' days');
              }
              $('.loading-wrapper .ca-loading').remove();
              test_modal.modal('hide');
              test_confirm_modal.modal('show');
              updateTests();
            }
          }
        });
      });
    } else {
      updateTestMessages(errors.test_data, 'test_data');
      updateTestMessages(errors.check_test, 'check_test');
      updateTestMessages(errors.test_deadline, 'test_deadline');
    }
  };

  var updateTests = function(){
    var test_modal = $('.modal.applicant-test-modal');
    var url = test_modal.attr('data-getTestsUrl');

    if(url){
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        async: false,
        success: function(result){
          if(result.groups_tests_html){
            test_modal.find('.modal-body .loading-wrapper').html(result.groups_tests_html);
            test_modal.find('input.radio-icheck').iCheck({ handle: 'radio' });
            test_modal.find('input.checkbox-icheck').iCheck({ handle: 'checkbox' });
            test_modal.find('#applicant_deadline').datetimepicker({
              format: 'YYYY-MM-DD HH:mm'
            });
          }
        }
      });
    }
  };

  var showMiniProfile = function(app_table, id, show_all){
    var short_data_row = app_table.find('tr.short-data[data-id='+id+']');
    var profile_row = app_table.find('tr.mini-profile[data-id='+id+']');
    var checkbox = short_data_row.find('.check .icheckbox input').clone();

    short_data_row.addClass('hidden');
    short_data_row.find('.check .icheckbox').remove();
    profile_row.removeClass('hidden');
    profile_row.find('.check').html(checkbox);
    profile_row.find('input.checkbox-icheck').iCheck({ handle: 'checkbox' });

    if(!show_all){
      app_table.css('width', '100%');
      updateResizableColumns();
      $(app_table.parents('.table-wrap')).scrollTo($(profile_row));
    }
  };

  var hideMiniProfile = function(app_table, id){
    var short_data_row = app_table.find('tr.short-data[data-id='+id+']');
    var profile_row = app_table.find('tr.mini-profile[data-id='+id+']');
    var checkbox = profile_row.find('.check .icheckbox input').clone();

    profile_row.addClass('hidden');
    profile_row.find('.check .icheckbox').remove();
    short_data_row.removeClass('hidden');
    short_data_row.find('.check .td-content').html(checkbox);
    short_data_row.find('input.checkbox-icheck').iCheck({ handle: 'checkbox' });
  };

  var showAllMiniProfiles = function(app_table){
    $.each(app_table.find('tr.mini-profile.hidden'), function(){
      showMiniProfile(app_table, $(this).attr('data-id'), true);
    });

    app_table.css('width', '100%');
    updateResizableColumns();
  };

  var hideAllMiniProfiles = function(app_table){
    $.each(app_table.find('tr.short-data.hidden'), function(){
      hideMiniProfile(app_table, $(this).attr('data-id'));
    });
  };

  var showTests = function(groups_element){
    hideTests();
    $.each(groups_element.find('.test-filter-input'), function(){
      $('.form-group.tests-list .tests-group.category_' + $(this).val()).removeClass('hidden');
    });
  };

  var hideTests = function(){
    $('.form-group.tests-list .tests-group').addClass('hidden');
  };

  var showTestCategories = function(groups_element){
    var categories = [];

    $.each(groups_element.find('.test-filter-input.checkbox-icheck:checked'), function(){
      categories.push($(this).val());
    });

    hideTests();

    if(categories.length > 0){
      $.each(categories, function(i, val){
        $('.form-group.tests-list .tests-group.category_' + val).removeClass('hidden');
      });
    } else {
      showTests(groups_element);
    }
  };

  var testErrors = function(){
    var test_modal = $('.modal.applicant-test-modal');
    var checked_test = test_modal.find('.tests-list .test input.radio-icheck:checked').first().val();
    var timeframe_to_pass = test_modal.find('input#applicant_timeframe_to_pass').val();
    var errors = {test_data: [], check_test: [], test_deadline: []};

    if(!checked_test){ errors.test_data.push('Please select a test'); }
    if(!timeframe_to_pass){ errors.test_deadline.push('Please set a test timeframe to pass'); }
    if(timeframe_to_pass && !testDeadlineCorrect()){ errors.test_deadline.push('Test timeframe to pass must be greater than 0'); }

    $.each(test_modal.find('.results li.error.check_test'), function(){
      errors.check_test.push($(this).html());
    });

    return(errors);
  };

  var checkTestDeadline = function(){
    var test_modal = $('.modal.applicant-test-modal');
    var timeframe_to_pass = test_modal.find('input#applicant_timeframe_to_pass').val();
    var errors = [];

    if(timeframe_to_pass && !testDeadlineCorrect()){ errors.push('Test timeframe to pass must be greater than 0'); }

    updateTestMessages(errors, 'test_deadline');
  };

  var checkTestData = function(){
    var errors = testErrors();

    updateTestMessages(errors.test_data, 'test_data');
    updateTestMessages(errors.check_test, 'check_test');
    updateTestMessages(errors.test_deadline, 'test_deadline');
  };

  var updateTestMessages = function(messages, class_name){
    var test_modal = $('.modal.applicant-test-modal');

    if(class_name){
      test_modal.find('.results li.error.' + class_name).remove();
      $.each(messages, function(){ test_modal.find('.results').append('<li class="error ' + class_name + '">' + this + '</li>'); });
    }
  };

  var testDeadlineCorrect = function(){
    var test_modal = $('.modal.applicant-test-modal');
    var timeframe_to_pass = test_modal.find('input#applicant_timeframe_to_pass').val();

    if(timeframe_to_pass){
      if(!$.isNumeric(timeframe_to_pass)) {
        return false;
      }

      if(parseInt(timeframe_to_pass) <= 0){
        return false;
      }

      return true;
    } else {
      return false;
    }
  };

  var checkTest = function(test_id, update_errors){
    var test_modal = $('.modal.applicant-test-modal');
    var url = test_modal.attr('data-checkTestUrl');
    var loading = test_modal.find('.loading-wrapper');
    var app_ids = null;

    loading.prepend('<div class="ca-loading"></div>');

    $.ajax({
      type: 'GET',
      url: url,
      data: { applicant: { app_ids: getIds(), test_id: test_id } },
      async: false,
      success: function(result){
        var errors = [];
        var element_deadline = test_modal.find('#applicant_timeframe_to_pass');
        app_ids = result.app_ids;

        if(result.timeframe_to_pass && !element_deadline.val()){
          test_modal.find('#applicant_timeframe_to_pass').val(result.timeframe_to_pass);
        }
        if(result.messages.length > 0){
          $.each(result.messages, function(){ errors.push(this); });
        }
        updateTestMessages(errors, 'check_test');
        if(update_errors){
          checkTestData();
        }
        loading.find('.ca-loading').remove();
      }
    });

    return app_ids;
  };

  var actionStudents = function(e){
    var app_ids = getIds();
    var link = $(e.currentTarget);
    // share-students-button was commented out since CA-193
    var is_share_button = e.currentTarget.id === 'share-students-button';

    if(app_ids.length > 0){
      if (is_share_button) {
        $('#checked-students').val(app_ids);
      } else {
        var url = (link.attr('data-defaultUrl') || link.attr('href')) + '?student_ids=' + app_ids;
        link.attr('href', url);
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return {
    setState: setState,
    getIds: getIds,
    sendEmail: sendEmail,
    updateColumn: updateColumn,
    sendToCvScreening: sendToCvScreening,
    applyToJob: applyToJob,
    test: test,
    updateResizableColumns: updateResizableColumns,
    showMiniProfile: showMiniProfile,
    hideMiniProfile: hideMiniProfile,
    showAllMiniProfiles: showAllMiniProfiles,
    hideAllMiniProfiles: hideAllMiniProfiles,
    showTests: showTests,
    hideTests: hideTests,
    showTestCategories: showTestCategories,
    checkTestData: checkTestData,
    checkTest: checkTest,
    checkTestDeadline: checkTestDeadline,
    transferToJob: transferToJob,
    actionStudents: actionStudents,
    setUrlParams: setUrlParams
  };
});
